import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  gap: 20px;
  bottom: 100px;
  right: 50px;
  z-index: 9999;
`

export const BoxItem = styled.div`
  cursor: pointer;

  span {
    color: #001035;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }

  &:hover {
    span {
      color: #b98f67;
      text-shadow: 0px 0px 10px rgba(233, 200, 163, 0.8);
    }
  }

  &:target {
    span {
      color: #fff;
      text-shadow: 0px 0px 10px rgba(233, 200, 163, 0.8);
    }
  }

  @media (max-width: 729px) {
    span {
      display: none;
    }

    img {
      width: 56px;
    }
  }
`
